import { render, staticRenderFns } from "./QuizGroupMaker.vue?vue&type=template&id=a6a00c44&scoped=true&"
import script from "./QuizGroupMaker.vue?vue&type=script&lang=ts&"
export * from "./QuizGroupMaker.vue?vue&type=script&lang=ts&"
import style0 from "./QuizGroupMaker.vue?vue&type=style&index=0&id=a6a00c44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6a00c44",
  null
  
)

export default component.exports